import React from "react";
import SecurityIncidentTable from "./securityIncidentTable";

class SecurityIncident extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenCreateRequest: props.location.aboutProps ? props.location.aboutProps.isOpenCreateRequest : false
    }
  }

  /**
   * fetch data from new props
   * @param {*} newProps 
   * @param {*} state 
   * @returns 
   */
  static getDerivedStateFromProps(newProps, state) {
    if (
      newProps.location?.notificationProps?.isOpenRequest !== (state || {}).isOpenCreateRequest ||
      newProps.location?.notificationProps !== (state || {}).notificationProps ||
      newProps.location?.notificationProps?.isReply !== (state || {}).notificationProps?.isReply ||
      newProps.location?.notificationProps?.recordId !== (state || {}).notificationProps?.recordId ||
      newProps.location?.notificationProps?.message !== (state || {}).notificationProps?.message ||
      newProps.location?.notificationProps?.createdOn !== (state || {}).notificationProps?.createdOn
    ) {
      // this.LoadData();
      return {
        notificationProps: newProps.location?.notificationProps?.isOpenRequest?newProps.location?.notificationProps:undefined,
        isOpenCreateRequest: newProps.location?.notificationProps?.isOpenRequest
      };
    } else {
      return newProps;
    }
  }

  render() {
    const { isOpenCreateRequest, notificationProps } = this.state;
    return (
      <div className={"requests-body-wrapper"}>
        <div className={"row request-table"}>
          {
            <SecurityIncidentTable
              isOpenCreateRequest={isOpenCreateRequest || false}
              history={this.props.history}
              notificationProps={isOpenCreateRequest ?notificationProps :undefined}
              handelOpenRequest={() => {
                // this.props?.location?.notificationProps=undefined
                //const { notificationProps } = this.state;
                this.setState({ notificationProps: "" ,isOpenCreateRequest:false});
              }}
            />
          }
        </div>
      </div>
    );
  }
}
export default SecurityIncident;
